import React from 'react';

import * as Styled from './StyledCardsTradeSpace';

export const CardsTradeSpace = () => (
    <Styled.CardsTradeSpace>
        <Styled.CardsHead>
            <h2>Espaço de troca</h2>
        </Styled.CardsHead>

        <Styled.CardsBody>
            <div className="card">
                <span className="icon fab fa-whatsapp" aria-hidden="true" />
                <span className="title">Whatsapp</span>
                <span className="descr">
                    Você já está no grupo de praticantes 100-10-1? Este é um ambiente mais
                    descontraído para compartilharmos conteúdo, experiências e lembretas importantes
                    do programa.
                </span>
                <a
                    className="buttn"
                    href="https://100os.net/whatsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="text">Fale conosco</span>
                </a>
            </div>
        </Styled.CardsBody>
    </Styled.CardsTradeSpace>
);
